import { useQuery } from '@tanstack/react-query';
import { ApiUrlEnum } from 'src/config/endPointsConfig';
import { getImpacts, getProgramXVolet } from '../services/impact.service';

export const useLoadImpacts = ({ program, volet }: { program?: string; volet?: string }) => {
  return useQuery({
    queryKey: [ApiUrlEnum.impact, program, volet],
    queryFn: () => getImpacts({ program, volet }),
  });
};

export const useLoadProgramxVolets = () => {
  return useQuery({
    queryKey: [ApiUrlEnum.programxvolet],
    queryFn: () => getProgramXVolet(),
  });
};
